import React from 'react';
import { HelpBlock } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../translations/lang/en-US.json';

export default class PasswordStrengthInfo extends React.Component {
	render() {
		return (
			<HelpBlock className="font-medium">
				<ul
					style={{
						paddingLeft: '16px',
						margin: '0px',
					}}
				>
					<li>
						<FormattedMessage
							id="errorPassword1"
							defaultMessage={defaultMsg.errorPassword1}
						/>
					</li>
					<li>
						<FormattedMessage
							id="errorPassword2"
							defaultMessage={defaultMsg.errorPassword2}
						/>
					</li>
				</ul>
			</HelpBlock>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/auth/PasswordStrengthInfo.jsx